// src/pages/LandingPage.jsx
import React from 'react';
import Slider from 'react-slick';
import logo from '../assets/logo.png';
import '../styles/LandingPage.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import img1 from '../assets/carousel1.jpg';
import img2 from '../assets/carousel2.jpg';
import img3 from '../assets/carousel3.jpg';

export default function LandingPage() {
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  return (
    <div className="landing-container">
      <header className="landing-header">
        <img src={logo} alt="The Desi Network Logo" className="logo" />
        <h1 className="headline">The Desi Network</h1>
        <h2 className="subhead">
          WHO WILL SHAPE THE NEXT GENERATION OF SOUTH ASIAN LEADERS IF NOT US?
        </h2>
        <p className="subheadline">
          Connecting South Asian professionals, apprentices, and graduates nationwide — your community, your future.
        </p>
      </header>

      <section className="who-we-are">
        <h2>About Us</h2>
        <p>
          The Desi Network exists to unite, represent, and empower South Asian apprentices, interns, and graduates across the UK. By building a connected community, amplifying underrepresented voices, and creating opportunities for growth, TDN champions inclusive, equitable, and inspiring pathways for the next generation of South Asian professionals.
        </p>
      </section>
      <div className="mission-values-container">
          <div className="mission-section">
            <h3>Mission</h3>
            <ul>
              <li> Build a Connected Community</li>
              <li> Amplify South Asian Voices</li>
              <li> Collaborate with Leaders</li>
              <li> Host Impactful Events</li>
              <li> Champion Inclusive Workplaces</li>
            </ul>
          </div>
          <div className="values-section">
            <h3>Values</h3>
            <ul>
              <li> Representation & Inclusion</li>
              <li> Unity</li>
              <li> Growth</li>
              <li> Excellence</li>
            </ul>
          </div>
        </div>

      <section className="carousel-section">
        <div className="carousel-title">Highlights from our launch event</div>
        <Slider {...carouselSettings}>
          <div>
            <img src={img1} alt="Event 1" className="carousel-image" />
          </div>
          <div>
            <img src={img2} alt="Event 2" className="carousel-image" />
          </div>
          <div>
            <img src={img3} alt="Event 3" className="carousel-image" />
          </div>
        </Slider>
      </section>

      <section id="contact" className="contact-section">
        <h2>Get in Touch</h2>
        <form action="mailto:info@thedesinetwork.co.uk" method="POST" encType="text/plain">
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            required
            className="contact-input"
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
            className="contact-input"
          />
          <textarea
            name="message"
            placeholder="Your Message"
            rows="4"
            required
            className="contact-textarea"
          />
          <button type="submit" className="contact-button">
            Send Message
          </button>
        </form>
      </section>

     <footer className="footer">
      <p className="footer-heading">Follow Us</p>
      <div className="social-links">
        <a href="https://instagram.com/thedesinetwork" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-instagram"></i> Instagram
        </a>
        <a href="https://linkedin.com/company/thedesinetwork" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-linkedin"></i> LinkedIn
        </a>
        <a href="mailto:info@thedesinetwork.co.uk">
          <i className="fas fa-envelope"></i> Email
        </a>
      </div>
      <p className="footer-copy">© {new Date().getFullYear()} The Desi Network. All rights reserved.</p>
    </footer>
    </div>
  );
}
